import { useHttpService } from "./http.service";
import { CredentialsChat, MessagesChat } from "../model/credentials-chat";
import { selectToken } from "../features/token/tokenSlice";
import { useAppSelector } from "../app/hooks";
import { selectCredentials } from "../features/credentials/credentialsSlice";
// import { Log } from "../functions";

export function useHttpEscalloChatService() {
  const { request } = useHttpService();
  const tokenChat = useAppSelector(selectToken);
  const credentials = useAppSelector(selectCredentials);
  const HOST =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_HOST
      : window.location.href.split("/")[2];
  const PROTOCOL = window.location.href.split("/")[0];
  const server = `${PROTOCOL}//${HOST}`;

  function auth(
    username: string,
    userKey: string,
    tokenChat: string
  ): Promise<CredentialsChat> {
    return request(
      "post",
      `${server}/${tokenChat}/public/auth`,
      JSON.stringify({ username, userKey, tokenChat }),
      {
        "Content-Type": "application/json",
      }
    ).then((res) => {
      if (!res.ok) {
        return Promise.reject({ res });
      }
      return res.json();
    });
  }

  function closeSession(): Promise<any> {
    return request(
      "post",
      `${server}/${tokenChat}/public/close-session`,
      JSON.stringify({
        tokenSessionUser: credentials?.tokenSessionUser,
        tokenChat,
      }),
      {
        "Content-Type": "application/json",
      }
    ).then((res) => {
      if (!res.ok) {
        return Promise.reject({ res });
      }
      return res.json();
    });
  }
  
  function getMessages(limit: number): Promise<MessagesChat> {
    return request(
      "get",
      `${server}/${tokenChat}/public/messages?tokenChat=${tokenChat}&tokenSessionUser=${credentials?.tokenSessionUser}&limit=${limit}`,
      undefined,
      {
        "Content-Type": "application/json",
      }
    ).then((res) => {
      if (!res.ok) {
        return Promise.reject({ res });
      }
      return res.json();
    });
  }

  function uploadFile(tokenChat: string, tokenSessionUser: string, file: File) {
    const formData = new FormData();
    formData.append("file", file);
    // Log('endpoint', `${server}/${tokenChat}/session/${tokenSessionUser}/upload-file`)
    return request(
      `put`,
      `${server}/${tokenChat}/session/${tokenSessionUser}/upload-file`,
      formData,
      undefined
    ).then((res) => {
      if (!res.ok) {
        return Promise.reject({ res });
      }
      return res.json();
    });
  }

  function getFieldsAuth() {
    return request(
      `get`,
      `${server}/${tokenChat}/public/get-fields-auth`,
      undefined,
      {
        "Content-Type": "application/json",
      }
    ).then((res) => {
      if (!res.ok) {
        return Promise.reject({ res });
      }
      return res.json();
    });
  }

  return {
    auth,
    uploadFile,
    getMessages,
    closeSession,
    getFieldsAuth,
  };
}
